<template>
  <div id="app">
    <nav id="nav" class="navbar navbar-light bg-light">
      <router-link v-if="$auth.isAuthenticated" to="/">New PSaaS AWS Account</router-link>
      <div v-if="!$auth.loading">
      <!-- show login when not authenticated -->
      <button type="button" class="btn btn-light" v-if="!$auth.isAuthenticated" @click="login">Log in</button>
      <!-- show logout when authenticated -->
      <button type="button" class="btn btn-light" v-if="$auth.isAuthenticated" @click="logout">Log out</button>
    </div>
    </nav>
    <router-view/>
    <h1 v-if="$auth.loading">Loading...</h1>

  </div>
</template>

<style>
#app {
  text-align: center;
}

/* #nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
</style>

<script>

export default {
  name: "home",
  methods: {
    // Log the user in
    login() {
      this.$auth.loginWithRedirect();
    },
    // Log the user out
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    }
  }
};
</script>